// Hook de cache para Habits Services usando Tanstack Query
// Mantiene la misma interfaz que los servicios originales
import { useQuery } from '@tanstack/react-query'
import HabitsService from 'services/habits'

/**
 * Hook de cache para habits - NO CAMBIA LA LÓGICA EXISTENTE
 * Solo añade una capa de cache inteligente
 */
export const useHabitsQueries = userId => {
	// Cache para hábitos
	const habitsQuery = useQuery({
		queryKey: ['habits', userId],
		queryFn: () => HabitsService.getHabits({ userId }),
		staleTime: 3 * 60 * 1000, // 3 minutos - hábitos pueden cambiar
		cacheTime: 15 * 60 * 1000, // 15 minutos en cache
		enabled: !!userId,
		retry: 2,
		retryDelay: 1000
	})

	// Cache para tips
	const tipsQuery = useQuery({
		queryKey: ['habits-tips', userId],
		queryFn: () => HabitsService.getTips({ userId }),
		staleTime: 5 * 60 * 1000, // 5 minutos - tips cambian poco
		cacheTime: 30 * 60 * 1000, // 30 minutos en cache
		enabled: !!userId,
		retry: 2,
		retryDelay: 1000
	})

	// Función wrapper que mantiene la interfaz original para hábitos
	const getCachedHabits = () => {
		return new Promise((resolve, reject) => {
			if (habitsQuery.data) {
				resolve({ status: 200, data: habitsQuery.data })
			} else if (habitsQuery.error) {
				reject(habitsQuery.error)
			} else {
				habitsQuery.refetch().then(result => {
					if (result.data) {
						resolve({ status: 200, data: result.data })
					} else {
						reject(result.error || new Error('No habits data available'))
					}
				})
			}
		})
	}

	// Función wrapper para tips
	const getCachedTips = () => {
		return new Promise((resolve, reject) => {
			if (tipsQuery.data) {
				resolve({ status: 200, data: tipsQuery.data })
			} else if (tipsQuery.error) {
				reject(tipsQuery.error)
			} else {
				tipsQuery.refetch().then(result => {
					if (result.data) {
						resolve({ status: 200, data: result.data })
					} else {
						reject(result.error || new Error('No tips data available'))
					}
				})
			}
		})
	}

	return {
		// Datos de las queries
		habits: habitsQuery.data,
		tips: tipsQuery.data,

		// Estados de loading
		habitsLoading: habitsQuery.isLoading,
		tipsLoading: tipsQuery.isLoading,

		// Errores
		habitsError: habitsQuery.error,
		tipsError: tipsQuery.error,

		// Funciones wrapper que mantienen la interfaz original
		getCachedHabits,
		getCachedTips,

		// Funciones para invalidar cache cuando sea necesario
		invalidateHabits: () => habitsQuery.refetch(),
		invalidateTips: () => tipsQuery.refetch()
	}
}

export default useHabitsQueries
